import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';
import { QuillModule } from 'ngx-quill';
import { EllipsisModule } from 'ngx-ellipsis';

import { QuickNotesViewDialog } from './quick-notes-view-dialog/quick-notes-view-dialog';
import { NoteComponent } from '@notes/note/note.component';
import { NgRatingBarModule } from 'ng-rating-bar';
import { NoteListComponent } from '@notes/note-list/note-list.component';
import { AddNoteComponent } from '@notes/add-note/add-note.component';

const components = [
	QuickNotesViewDialog,
	NoteComponent,
	NoteListComponent,
	AddNoteComponent,
];

@NgModule({
	declarations: [components],
	imports: [CommonModule, CoreModule, QuillModule.forRoot(), EllipsisModule, NgRatingBarModule],
	exports: [...components],
})
export class NotesModule {}
